import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService, MetadataService, ExpressionFilter, Condition, ExpressionRule, Operator } from '../../ubi-core/ubi-core.module';
import { ToastrService } from 'ngx-toastr';
import { DynamicGridComponent } from '../../dynamic-entity/dynamic-entity.module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UbiFilterService } from '../../theme/index';
import { EventEmitter } from 'events';
import { Observable } from 'rxjs/Observable';
import { DatePipe } from '@angular/common';
import { LocalizedDatePipe } from '../../ubi-core/pipes/LocalizedDatePipe';
import { saveAs } from 'file-saver';

declare var $: any;

@Component({
  selector: 'app-mapas',
  templateUrl: './mapa.component.html',
  styleUrls: ['./mapa.component.scss']
})
export class MapaComponent extends DynamicGridComponent implements OnInit {
  name = 'angular';
  rules_basic: any = {};

  protected columns = [];

  private processing = false;
  private gridHasData = false;
  private reportType = null;
  private truckingCompanies = [];
  private truckLoadReports = [];
  private vessels = [];
  private customers = [];
  private vesselAndProcessId = null;
  private customerId = null;
  private truckingCompanyId = null;
  private truckRegistration = null;
  private truckTrailer = null;
  private reportNumber = null;
  private startDate = this.getTodayDateString() + 'T00:00';
  private endDate = this.getTodayDateString() + 'T23:59';

  private visibleElements = {
    reportSelection: true,
    exportTruckLoadingReport: false,
    damagesReport: false,
    vesselsDropDownFilter: false,
    vesselsDropDown: false,
    customersDropDown: false,
    truckInfo: false,
    dateRange: false,
    announcementInfo: false,
    queryBuilderFilters: true
  };

  private damagesReport = {
    OperationStartDate: this.getTodayDateString() + 'T00:00',
    OperationEndDate: this.getTodayDateString() + 'T23:59',
    Observations: null
  };

  private announcementInfo = {
    Id: null,
    Date: null,
    Customer: null
  }

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService, protected toastr: ToastrService) {
    super(baseservice, metadataservice, router, route, modalService, filterservice);
  }

  ngOnInit() {

    if (this.router.url.indexOf('loadtruck') > -1) {
      this.visibleElements.reportSelection = false;
      this.visibleElements.exportTruckLoadingReport = true;
      this.visibleElements.truckInfo = true;
      this.visibleElements.vesselsDropDown = true;
      this.visibleElements.dateRange = true;

      this.getTruckingCompanies();
      this.getGeneratedTruckLoadReports({ pageSize: 10, offset: 0 });
      this.getVessels();
    } else {
      this.visibleElements.reportSelection = true;
      this.visibleElements.exportTruckLoadingReport = false;
      this.visibleElements.truckInfo = false;
      this.visibleElements.vesselsDropDown = false;

      this.entity = 'movements';
      this.baseservice.setEntity(this.entity);
      this.metadataservice.setEntity(this.entity);
      this.getMetadata();
    }

    this.onDataLoaded.subscribe((data) => this.onGridDataLoaded(data));
  }

  getMetadata() {
    if (this.reportType === 'ProductsInStock')
    {
      this.columns = [
        { 'prop': 'Id', 'name': 'Id', 'width': 49 },
        { 'prop': 'Type.Designation', 'name': 'Tipo', 'width': 40 },
        { 'prop': 'VesselAndProcess.Designation', 'name': 'Navio e contramarca' },
        { 'prop': 'Product', 'name': 'Código Produto', 'width': 90 },
        { 'prop': 'AnnouncementItemProduct.Announcement.SeaportCustomer.Designation', 'name': 'Cliente' },
        { 'prop': 'AnnouncementItemProduct.Announcement.Customer.Designation', 'name': 'Expedidor' },
        { 'prop': 'AnnouncementItemProduct.SoldTo.Designation', 'name': 'Consignatário' },
        { 'prop': 'AnnouncementItemProduct.ShipTo.Designation', 'name': 'Destinatário' },
        { 'prop': 'NumberDaysSinceCreation', 'name': 'Nº Dias', 'width': 40, 'sortable': false, 'cellClass': 'text-right' },
        { 'prop': 'CreatedOn', 'name': 'Movimentado em', pipe: new LocalizedDatePipe('pt-PT', 'yyyy/MM/dd hh:mm:ss') }
      ];
    } else if (this.reportType === 'StorageCostsReport') {
      this.columns = [
        { 'prop': 'EntryDate', 'name': 'Data entrada', pipe: new LocalizedDatePipe('pt-PT', 'yyyy/MM/dd hh:mm:ss') },
        { 'prop': 'ExitDate', 'name': 'Data saída', pipe: new LocalizedDatePipe('pt-PT', 'yyyy/MM/dd hh:mm:ss') },
        { 'prop': 'Vessel', 'name': 'Navio e contramarca' },
        { 'prop': 'ProductCode', 'name': 'Código Produto', 'width': 90 },
        { 'prop': 'SeaportCustomer', 'name': 'Cliente' },
        { 'prop': 'Customer', 'name': 'Expedidor' },
        { 'prop': 'SoldTo', 'name': 'Consignatário' },
        { 'prop': 'ShipTo', 'name': 'Destinatário' },
        { 'prop': 'GrossWeight', 'name': 'Peso Bruto', 'cellClass': 'text-right', 'width': 40 },
        { 'prop': 'DaysInPark', 'name': 'Nº Dias', 'width': 40, 'sortable': false, 'cellClass': 'text-right' },
      ];
    } else {
      this.columns =[
        { 'prop': 'Id', 'name': 'Id', 'width': 49 },
        { 'prop': 'Type.Designation', 'name': 'Tipo', 'width': 40 },
        { 'prop': 'VesselAndProcess.Designation', 'name': 'Navio e contramarca' },
        { 'prop': 'TruckingCompany.Designation', 'name': 'Emp. Camionagem' },
        { 'prop': 'TruckRegistration', 'name': 'Camião', 'width': 50 },
        { 'prop': 'TruckTrailer', 'name': 'Galera', 'width': 50 },
        { 'prop': 'Product', 'name': 'Código Produto', 'width': 90 },
        { 'prop': 'AnnouncementItemProduct.SoldTo.Designation', 'name': 'Consignatário' },
        { 'prop': 'AnnouncementItemProduct.ShipTo.Designation', 'name': 'Destinatário' },
        { 'prop': 'CreatedOn', 'name': 'Movimentado em', pipe: new LocalizedDatePipe('pt-PT', 'yyyy/MM/dd hh:mm:ss') }
      ];
    }

    this.columns = [...this.columns];
  }

  onVesselChange(event) {
    if (this.vesselAndProcessId === '') {
      this.vesselAndProcessId = null;
    }

    this.view();
  }

  onCustomerChange(event) {
    if (this.customerId === '') {
      this.customerId = null;
    }

    this.view();
  }  

  onSearchTruckLoadReportsClick(event) {
    this.getGeneratedTruckLoadReports({ pageSize: 10, offset: 0 });
  }

  onGridDataLoaded(this, data) {
    this.gridHasData = data.data.length > 0;

    if (this.reportType === 'VesselUnloadDamagesReport') {
      if (data.data.length > 0) {
        if (this.vesselAndProcessId != null && data.data[0].VesselAndProcess != null &&
          data.data[0].VesselAndProcess.OperationStartDate &&
          data.data[0].VesselAndProcess.OperationEndDate) {
          this.damagesReport.OperationStartDate = data.data[0].VesselAndProcess.OperationStartDate.substring(0, 16);
          this.damagesReport.OperationEndDate = data.data[0].VesselAndProcess.OperationEndDate.substring(0, 16);
          this.damagesReport.Observations = data.data[0].VesselAndProcess.Observations;
        } else {
          this.getUnloadVesselMovementsMinAndMaxDates(data.data[0].VesselAndProcessID);
        }
        this.baseservice.setEntity('Movements');
      } else {
        this.damagesReport.OperationStartDate = this.getTodayDateString() + 'T00:00';
        this.damagesReport.OperationEndDate = this.getTodayDateString() + 'T23:59';
      }
    } else if (this.router.url.indexOf('loadtruck') > -1) {
      this.truckLoadReports = data.data;
    }
  }

  onSelectTruckLoadReport(event) {
    this.reportNumber = event.selected[0].ReportNumber;
    this.truckingCompanyId = event.selected[0].TruckingCompanyId;
    this.truckRegistration = event.selected[0].TruckRegistration;
    this.truckTrailer = event.selected[0].TruckTrailer;
  }


  onReportTypeChange(event: Event) {
    const reportTypeDropdown = <HTMLSelectElement>event.target;
    this.vesselAndProcessId = null;

    this.visibleElements.queryBuilderFilters = reportTypeDropdown.selectedIndex !== 4;

    if ($('#builder')[0].innerHTML !== '') {
      $('#builder').queryBuilder('destroy');
    }

    switch (reportTypeDropdown.selectedIndex) {
      case 0: // Pesquisa livre
        this.setupViewForAdvancedSearch();
        break;
      case 1: // Movimentos do dia
        this.setupViewForDailyMovementsReport();
        break;
      case 2: // Erros por falta de anúncio
        this.setupViewForErrorReport();
        break;
      case 3: // Existências
        this.setupViewForProductsInStockReport();
        break;
      case 4: // Custos de armazenamento
        this.setupViewForStorageCostsReport();
        break;
      case 5: // Avarias - Entrada
        this.setupViewForTruckUnloadDamagesReport();
        break;
      case 6: // Avarias - Descarga
        this.setupViewForVesselUnloadDamagesReport();
        break;
    }

    this.getMetadata();
    this.view();
  }

  onAnnouncementIdChange(event) {
    if (this.announcementInfo.Id != null) {
      this.processing = true;
      // Get annoucement info from db
      this.baseservice.setEntity('Reports/GetTruckUnloadDamagesReportInfo?announcementId=' + this.announcementInfo.Id);
      this.baseservice.getAll().subscribe(
        response => {
          if (response.AnnouncementDate != null) {
            this.announcementInfo.Date = response.AnnouncementDate.slice(0, 16).replace(/-/g, '/').replace('T', ' ');
          }

          this.announcementInfo.Customer = response.AnnouncementCustomer;
          this.startDate = this.damagesReport.OperationStartDate = response.MinDate.slice(0, 16);
          this.endDate = this.damagesReport.OperationEndDate = response.MaxDate.slice(0, 16);
          this.processing = false;
          this.view();
        },
        error => {
          this.processing = false;
          if (error.status === 404) {
            this.clearAnnouncementInfo();
            this.toastr.warning('Anúncio não encontrado.', '', { timeOut: 3000 });
          } else {
            this.clearAnnouncementInfo();
            console.log('Error getting announcement info: ' + error);
            this.toastr.error('Erro a obter a informação do anúncio.', '', { timeOut: 3000 });
          }
        });
      this.baseservice.setEntity('Movements');
    } else {
      this.clearAnnouncementInfo();
    }
  }

  public view() {
    this.baseservice.setEntity(this.entity);

    if ($('#builder')[0].innerHTML === '') {
      return null;
    }

    const result = $('#builder').queryBuilder('getRules');

    if (!$.isEmptyObject(result)) {
      // Since we can't order vessels descending by id we had to add a normal select to the component and the value from it
      // Add selected value to the rules
      if (this.visibleElements.vesselsDropDownFilter && this.vesselAndProcessId) {
        result.rules.push({
          id: 'VesselAndProcessID',
          field: 'VesselAndProcessID',
          type: 'integer',
          value: this.vesselAndProcessId,
          operator: 'equal'
        });
      }

      if (this.visibleElements.customersDropDown && this.customerId) {
        result.rules.push({
          id: 'CustomerID',
          field: 'CustomerID',
          type: 'integer',
          value: this.customerId,
          operator: 'equal'
        });
      }      

      if (this.visibleElements.truckInfo) {
        this.addTruckInfoFilters(result);
        this.addDateRangeFilter(result);
      }

      if (this.visibleElements.announcementInfo) {
        this.addAnnouncementInfoFilters(result);
        this.addDateRangeFilter(result);
      }
    
      this.getPage({ offset: 0 }, result);
    }

    return result;
  }

  getPage(pageInfo, filter, method = null) {
    if (this.reportType === 'StorageCostsReport') {
      super.getPage(pageInfo, filter, 'GetStorageCostsReport');
    } else {      
      super.getPage(pageInfo, filter, method);
    }
  }

  sortPage(sort, method) {
    if (this.reportType === 'StorageCostsReport') {
      super.sortPage(sort, 'GetStorageCostsReport');
    } else {      
      super.sortPage(sort, method);
    }    
  }

  private addTruckInfoFilters(filter) {
    if (this.truckingCompanyId != null && this.truckingCompanyId !== '') {
      filter.rules.push({
        id: 'TruckingCompanyID',
        field: 'TruckingCompanyID',
        type: 'integer',
        value: this.truckingCompanyId,
        operator: 'equal'
      });
    }
    if (this.truckRegistration != null && this.truckRegistration !== '') {
      filter.rules.push({
        id: 'TruckRegistration',
        field: 'TruckRegistration',
        type: 'string',
        value: this.truckRegistration,
        operator: 'equal'
      });
    }
    if (this.truckTrailer != null && this.truckTrailer !== '') {
      filter.rules.push({
        id: 'TruckTrailer',
        field: 'TruckTrailer',
        type: 'string',
        value: this.truckTrailer,
        operator: 'equal'
      });
    }
  }

  private addAnnouncementInfoFilters(filter) {
    if (this.announcementInfo.Id != null) {
      filter.rules.push({
        id: 'AnnouncementId',
        field: 'AnnouncementItemProduct.Announcement.Id',
        type: 'integer',
        value: this.announcementInfo.Id,
        operator: 'equal'
      });
    }
  }

  private addDateRangeFilter(filter) {
    filter.rules.push({
      id: 'CreatedOn',
      field: 'CreatedOn',
      type: 'datetime',
      operator: 'between',
      value: [this.startDate, this.endDate],
    });
  }

  private getTruckingCompanies() {
    this.baseservice.setEntity('TruckingCompanies');
    this.baseservice.getPage({ 'pageSize': 100, 'sortAsString': 'Designation' }).subscribe(
      response => this.truckingCompanies = response.data,
      error => {
        console.log('Error getting trucking companies list: ' + error);
        this.toastr.error('Erro a obter a lista de emrpesas de camionagem.', '', { timeOut: 3000 });
      });
  }

  private getVessels() {
    this.baseservice.setEntity('VesselAndProcesses');
    this.baseservice.getPage({ 'pageSize': 100, 'sortAsString': 'Id', 'orderByDescending': true }).subscribe(
      response => {
        this.vessels = response.data;
        this.visibleElements.vesselsDropDownFilter = true;
      },
      error => {
        console.log('Error getting vessels list: ' + error);
        this.toastr.error('Erro a obter a lista de navios.', '', { timeOut: 3000 });
      });
    this.baseservice.setEntity('Movements');
  }

  private getCustomers() {
    this.baseservice.setEntity('Customers');
    this.baseservice.getPage({ 'pageSize': 100, 'sortAsString': 'Designation' }).subscribe(
      response => {
        this.customers = response.data;
        this.visibleElements.customersDropDown = true;
      },
      error => {
        console.log('Error getting customers list: ' + error);
        this.toastr.error('Erro a obter a lista de clientes.', '', { timeOut: 3000 });
      });
    this.baseservice.setEntity('Movements');
  }  

  private getGeneratedTruckLoadReports(pageInfo) {
    const filter = new ExpressionFilter(Condition.AND);

    if (this.reportNumber != null && this.reportNumber !== '') {      
      filter.addRule(new ExpressionRule('TruckLoadReportNumber', Operator.Equal, +this.reportNumber));
    }

    if (this.truckingCompanyId != null && this.truckingCompanyId !== '') {
      filter.addRule(new ExpressionRule('TruckingCompanyID', Operator.Equal, this.truckingCompanyId));
    }  

    if (this.truckRegistration != null && this.truckRegistration !== '') {
      filter.addRule(new ExpressionRule('TruckRegistration', Operator.Contains, this.truckRegistration));
    }

    if (this.truckTrailer != null && this.truckTrailer !== '') {
      filter.addRule(new ExpressionRule('TruckTrailer', Operator.Contains, this.truckTrailer));
    }      

    if (this.vesselAndProcessId != null && this.vesselAndProcessId !== '') {
      filter.addRule(new ExpressionRule('VesselAndProcessID', Operator.Equal, this.vesselAndProcessId));
    }

    if (this.startDate != null && this.startDate !== '') {
      filter.addRule(new ExpressionRule('CreatedOn', Operator.Greater_or_Equal, this.startDate));
    }
    if (this.endDate != null && this.endDate !== '') {
      filter.addRule(new ExpressionRule('CreatedOn', Operator.Less_or_Equal, this.endDate));
    }

    this.page.sorts = [{ prop: 'ReportNumber', dir: 'desc' }];
    this.baseservice.setEntity('Reports');

    this.getPage(pageInfo, filter, 'GetGeneratedTruckLoadReports');
  }

  private sortGeneratedTruckLoadReports(sort) {
    this.baseservice.setEntity('Reports');
    this.sortPage(sort, 'GetGeneratedTruckLoadReports');
  }

  private resetFilterRules() {
    $('#builder').queryBuilder('reset');
  }

  private getRules() {
    return $('#builder').queryBuilder('getRules');
  }



  private setupViewForAdvancedSearch() {
    this.visibleElements.damagesReport = false;
    this.visibleElements.vesselsDropDownFilter = false;
    this.visibleElements.truckInfo = false;
    this.visibleElements.dateRange = false;
    this.visibleElements.announcementInfo = false;
    this.visibleElements.customersDropDown = false;

    $('#builder').queryBuilder({
      allow_groups: false,
      filters: [{
        id: 'TypeID',
        label: 'Tipo movimento',
        type: 'integer',
        input: 'select',
        values: { '1': 'Entrada', '2': 'Carga', '3': 'Descarga', '4': 'Saída' },
        operators: ['equal']
      },
      {
        id: 'TruckingCompany.Designation',
        label: 'Empresa camionagem',
        type: 'string',
        operators: ['begins_with']
      },
      {
        id: 'VesselAndProcess.Designation',
        label: 'Navio e contramarca',
        type: 'string',
        operators: ['begins_with']
      },
      {
        id: 'Product',
        label: 'Produto',
        type: 'string',
        operators: ['begins_with']
      },
      {
        id: 'CreatedOn',
        label: 'Movimentado em',
        type: 'datetime',        
        placeholder: 'YYYY-MM-DD HH:mm:ss',        
        operators: ['between'],
        value_separator: ',',
        validation: {
          callback: this.validateDateTimeRule
        }
      }]
    });
  }

  private setupViewForDailyMovementsReport() {
    this.visibleElements.damagesReport = false;
    this.visibleElements.vesselsDropDownFilter = true;
    this.visibleElements.truckInfo = false;
    this.visibleElements.dateRange = false;
    this.visibleElements.announcementInfo = false;
    this.visibleElements.customersDropDown = false;

    const startDate = this.getTodayDateString() + ' 00:00:00';
    const endDate = this.getTodayDateString() + ' 23:59:59';

    this.getVessels();

    $('#builder').queryBuilder({
      conditions: ['AND'],
      allow_groups: false,
      default_group_flags: {
        no_add_rule: true
      },
      filters: [
        {
          id: 'TypeID',
          label: 'Tipo movimento',
          type: 'integer',
          input: 'select',
          values: { '1': 'Entrada', '2': 'Carga', '3': 'Descarga', '4': 'Saída' },
          operators: ['equal']
        },
        {
          id: 'CreatedOn',
          label: 'Movimentado em',
          type: 'datetime',
          placeholder: 'YYYY-MM-DD HH:mm:ss',
          operators: ['between'],
          value_separator: ',',
          validation: {
            callback: this.validateDateTimeRule
          }
        }],
      rules: [
        {
          id: 'TypeID',
          operator: 'equal',
          value: '4',
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            value_readonly: false,
            no_delete: false
          }
        },
        {
          id: 'CreatedOn',
          operator: 'between',
          value: [startDate, endDate],
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            no_delete: true
          }
        }
      ]
    });
  }

  private setupViewForErrorReport() {
    this.visibleElements.damagesReport = false;
    this.visibleElements.vesselsDropDownFilter = false;
    this.visibleElements.truckInfo = false;
    this.visibleElements.dateRange = false;
    this.visibleElements.announcementInfo = false;
    this.visibleElements.customersDropDown = false;

    $('#builder').queryBuilder({
      conditions: ['AND'],
      allow_groups: false,
      default_group_flags: {
        no_add_rule: true
      },
      filters: [
        {
          id: 'AnnouncementItemProductID',
          label: 'Linha de anúncio',
          type: 'integer',
          operators: ['is_null']
        },
        {
          id: 'TypeID',
          label: 'Tipo movimento',
          type: 'integer',
          input: 'select',
          values: { '1': 'Entrada', '2': 'Carga', '3': 'Descarga', '4': 'Saída' },
          operators: ['equal', 'not_equal']
        }],
      rules: [
        {
          id: 'AnnouncementItemProductID',
          operator: 'is_null',
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            no_delete: true
          }
        },
        {
          id: 'TypeID',
          value: '4',
          operator: 'not_equal',
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            value_readonly: true,
            no_delete: true
          }
        }],
    });
  }

  private setupViewForProductsInStockReport() {
    this.visibleElements.damagesReport = false;
    this.visibleElements.vesselsDropDownFilter = true;
    this.visibleElements.truckInfo = false;
    this.visibleElements.dateRange = false;
    this.visibleElements.announcementInfo = false;
    this.visibleElements.customersDropDown = false;

    this.getVessels();

    $('#builder').queryBuilder({
      conditions: ['AND'],
      allow_groups: false,
      default_group_flags: {
        no_add_rule: true
      },
      filters: [
        {
          id: 'TypeID',
          label: 'Tipo movimento',
          type: 'integer',
          input: 'select',
          value_separator: ',',
          operators: ['not_equal'],
          values: { '2': 'Carga', '4': 'Saída' },
          no_delete: false,
        },
        {
          id: 'AnnouncementItemProduct.StatusID',
          label: 'Estado',
          type: 'integer',
          input: 'select',
          value_separator: ',',
          operators: ['equal'],
          values: { '3': 'Em stock' },
          no_delete: false,
        }],
      condition: 'AND',
      rules: [
        {
          id: 'TypeID',
          value: '2',
          operator: 'not_equal',
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            value_readonly: true,
            no_delete: true
          }
        },
        {
          id: 'TypeID',
          value: '4',
          operator: 'not_equal',
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            value_readonly: true,
            no_delete: true
          }
        },
        {
          id: 'AnnouncementItemProduct.StatusID',
          value: '3',
          operator: 'equal',
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            value_readonly: true,
            no_delete: true
          }
        }
      ]
    });
  }

  private setupViewForStorageCostsReport() {
    this.visibleElements.damagesReport = false;
    this.visibleElements.vesselsDropDownFilter = true;
    this.visibleElements.truckInfo = false;
    this.visibleElements.dateRange = false;
    this.visibleElements.announcementInfo = false;
    this.visibleElements.customersDropDown = true;

    // const startDate = this.getTodayDateString() + ' 00:00:00';
    const startDate = new Date().getFullYear() + '-01-01' + ' 00:00:00';
    const endDate = this.getTodayDateString() + ' 23:59:59';

    this.getVessels();
    this.getCustomers();

    $('#builder').queryBuilder({
      conditions: ['AND'],
      allow_groups: false,
      default_group_flags: {
        no_add_rule: true
      },
      filters: [
        {
          id: 'EntryDate',
          label: 'Entrada em',
          type: 'datetime',
          placeholder: 'YYYY-MM-DD HH:mm:ss',
          operators: ['between'],
          value_separator: ',',
          validation: {
            callback: this.validateDateTimeRule
          }
        },
        {
          id: 'ExitDate',
          label: 'Saída em',
          type: 'datetime',
          placeholder: 'YYYY-MM-DD HH:mm:ss',
          operators: ['between'],
          value_separator: ',',
          validation: {
            callback: this.validateDateTimeRule
          }
        }],
      rules: [
        {
          id: 'EntryDate',
          operator: 'between',
          value: [startDate, endDate],
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            no_delete: true
          }
        },
        {
          id: 'ExitDate',
          operator: 'between',
          value: [startDate, endDate],
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            no_delete: true
          }          
        }
      ]
    });    
  }

  private setupViewForTruckUnloadDamagesReport() {
    this.visibleElements.damagesReport = true;
    this.visibleElements.vesselsDropDownFilter = false;
    this.visibleElements.truckInfo = false;
    this.visibleElements.dateRange = true;
    this.visibleElements.announcementInfo = true;
    this.visibleElements.customersDropDown = false;

    $('#builder').queryBuilder({
      conditions: ['AND'],
      allow_groups: false,
      default_group_flags: {
        no_add_rule: true
      },
      filters: [
        {
          id: 'TypeID',
          label: 'Tipo movimento',
          type: 'integer',
          input: 'select',
          values: { '1': 'Entrada' },
          operators: ['equal']
        }
      ],
      rules: [
        {
          id: 'TypeID',
          operator: 'equal',
          value: '1',
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            value_readonly: true,
            no_delete: true
          }
        }
      ]
    });
  }

  private setupViewForVesselUnloadDamagesReport() {
    this.visibleElements.damagesReport = true;
    this.visibleElements.vesselsDropDownFilter = true;
    this.visibleElements.truckInfo = false;
    this.visibleElements.dateRange = false;
    this.visibleElements.announcementInfo = false;
    this.visibleElements.customersDropDown = false;

    this.getVessels();

    $('#builder').queryBuilder({
      conditions: ['AND'],
      allow_groups: false,
      default_group_flags: {
        no_add_rule: true
      },
      filters: [
        {
          id: 'TypeID',
          label: 'Tipo movimento',
          type: 'integer',
          input: 'select',
          values: { '3': 'Descarga' },
          operators: ['equal']
        }
      ],
      rules: [
        {
          id: 'TypeID',
          operator: 'equal',
          value: '3',
          flags: {
            filter_readonly: true,
            operator_readonly: true,
            value_readonly: true,
            no_delete: true
          }
        }
      ]
    });
  }

  private exportReport(format) {
    switch (this.reportType) {
      case 'DailyMovements':
        this.exportDailyMovements(format);
        break;
      case 'ErrorReport':
        this.exportErrorReport(format);
        break;
      case 'ProductsInStock':
        this.exportProductsInStock(format);
        break;
      case 'TruckUnloadDamagesReport':
        this.exportTruckUnloadDamagesReport(format);
        break;
      case 'VesselUnloadDamagesReport':
        this.exportVesselUnloadDamagesReport(format);
        break;
    }
  }

  private exportTruckLoadMovements(version) {
    this.processing = true;
    this.baseservice.setEntity('Movements/GenerateTruckLoadSequenceNumber');
    if (this.truckTrailer === '') {
      this.truckTrailer = null;
    }

    const request = {
      ReportNumber: this.reportNumber,
      TruckingCompanyId: this.truckingCompanyId,
      TruckRegistration: this.truckRegistration,
      TruckTrailer: this.truckTrailer,
      Print: true
    };

    this.baseservice.postRequest(request).subscribe(
      response => {
        if (response != null) {
          const reportRequest = {
            'Path': 'TruckLoadMovements',
            'Parameters': {
              'ReportNumber': response,
              'Version': version
            }
          };
          this.requestReport(reportRequest, 'TruckLoadMovements.pdf', 'PDF');
        } else {
          this.toastr.warning('Não foram encontrados movimentos', '', { timeOut: 3000 });
          this.processing = false;
        }
      },
      error => {
        console.log('Error getting sequence number: ' + error);
        this.toastr.error('Erro a gerar o número da guia.', '', { timeOut: 3000 });
        this.processing = false;
      }
    );
  }

  private exportDailyMovements(format) {
    const rules = this.getRules();

    if (rules != null) {
      if (!this.isValidDateTime(rules.rules[0].value[0])) {
        this.toastr.warning('Data de início inválida', '', { timeOut: 3000 });
        return;
      }

      if (!this.isValidDateTime(rules.rules[0].value[1])) {
        this.toastr.warning('Data de fim inválida', '', { timeOut: 3000 });
        return;
      }

      const request = {
        'Path': 'DailyMovements',
        'Parameters': {
          'DataInicio': rules.rules[0].value[0],
          'DataFim': rules.rules[0].value[1],
          'VesselAndProcessID': this.vesselAndProcessId
          
        }
      };
      this.requestReport(request, 'DailyMovementsReport' + this.getFileExtension(format), format);
    } else {
      this.toastr.warning('Deve definir as datas de início e fim de turno', '', { timeOut: 4000 });
    }
  }

  private exportErrorReport(format) {
    const request = {
      'Path': 'ErrorReport'
    };
    this.requestReport(request, 'ErrorReport' + this.getFileExtension(format), format);
  }

  private exportProductsInStock(format) {
    const rules = this.getRules();

    const request = {
      'Path': 'ProductsInStock',
      'Parameters': {
        'VesselAndProcessId': this.vesselAndProcessId
      }
    };
    this.requestReport(request, 'ProductsInStockReport' + this.getFileExtension(format), format);
  }

  private exportTruckUnloadDamagesReport(format) {
    const rules = this.getRules();

    // Trucking company and truck registration are required for truck unload report
    if (this.announcementInfo.Id != null && this.startDate != null && this.endDate != null &&
      this.damagesReport.OperationStartDate != null && this.damagesReport.OperationEndDate != null) {

      const request = {
        'Path': 'TruckUnloadDamagesReport',
        'Parameters': {
          'AnnouncementId': this.announcementInfo.Id,
          'StartDate': this.startDate,
          'EndDate': this.endDate,
          'OperationStartDate': this.damagesReport.OperationStartDate,
          'OperationEndDate': this.damagesReport.OperationEndDate,
          'Observations': this.damagesReport.Observations
        }
      };

      this.requestReport(request, 'TruckUnloadDamagesReport' + this.getFileExtension(format), format);
      // this.saveOperationInfo();
    } else {
      this.toastr.warning('Por favor, preencha todos os campos obrigatórios', '', { timeOut: 4000 });
    }
  }

  private exportVesselUnloadDamagesReport(format) {
    const rules = this.getRules();

    // Vessel is required for vessel unload report
    if (this.vesselAndProcessId == null) {
      this.toastr.warning('Deve seleccionar um navio', '', { timeOut: 4000 });
    } else {
      const request = {
        'Path': 'DamagesReport',
        'Parameters': {
          'VesselAndProcessID': this.vesselAndProcessId,
          'OperationStartDate': this.damagesReport.OperationStartDate,
          'OperationEndDate': this.damagesReport.OperationEndDate,
          'Observations': this.damagesReport.Observations
        }
      };

      this.requestReport(request, 'DamagesReport' + this.getFileExtension(format), format);
      this.saveOperationInfo();
    }
  }

  private requestReport(request: object, fileName: string, format: string) {
    this.processing = true;
    this.baseservice.setEntity('Reports/ExportTo' + format);
    this.baseservice.getFile(request, 'application/pdf').subscribe(
      response => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response);
        link.download = fileName;
        link.click();
        this.processing = false;
      },
      error => {
        console.log('Error getting report: ' + error);
        this.toastr.error('Erro a gerar o relatório.', '', { timeOut: 3000 });
        this.processing = false;
      }
    );
    this.baseservice.setEntity('Movements');
  }

  private getUnloadVesselMovementsMinAndMaxDates(vesselAndProcessId) {
    // Get max and min dates
    this.baseservice.setEntity('Movements/GetVesselMovementsStartAndEndDates?vesselAndProcessId=' + vesselAndProcessId);
    this.baseservice.getAll().subscribe(
      response => {
        if (response.MinDate != null) {
          this.damagesReport.OperationStartDate = response.MinDate.substring(0, 16);
        }
        if (response.MaxDate != null) {
          this.damagesReport.OperationEndDate = response.MaxDate.substring(0, 16);
        }
      },
      error => {
        console.log('Error getting min and max dates: ' + error);
        this.toastr.error('Erro a obter as datas de início e fim de operação.', '', { timeOut: 3000 });
      });
  }

  private clearAnnouncementInfo() {
    this.announcementInfo.Date = null;
    this.announcementInfo.Customer = null;
    this.startDate = this.damagesReport.OperationStartDate = this.getTodayDateString() + 'T00:00';
    this.endDate = this.damagesReport.OperationEndDate = this.getTodayDateString() + 'T23:59';
  }

  private saveOperationInfo() {
    const request = {
      'VesselAndProcessId': this.vesselAndProcessId,
      'StartDate': this.damagesReport.OperationStartDate,
      'EndDate': this.damagesReport.OperationEndDate,
      'Observations': this.damagesReport.Observations
    };
    this.processing = true;
    this.baseservice.setEntity('VesselAndProcesses/SaveOperationInfo');
    this.baseservice.postRequest(request).subscribe(
      response => {
        this.processing = false;
      },
      error => {
        console.log('Error getting report: ' + error);
        this.toastr.error('Erro a gerar o relatório.', '', { timeOut: 3000 });
        this.processing = false;
      }
    );
    this.baseservice.setEntity('Movements');
  }

  private getTodayDateString() {
    const today: Date = new Date();
    const day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
    const month = today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1).toString() : (today.getMonth() + 1).toString();
    return today.getFullYear() + '-' + month + '-' + day;
  }

  private validateDateTimeRule(value, rule) {
    let isValid: boolean;
    // Single datetime field
    if (typeof (value) === 'string') {
      isValid = MapaComponent.prototype.isValidDateTime(value);
    } else { // Between datetime
      isValid = MapaComponent.prototype.isValidDateTime(value[0]) &&
        MapaComponent.prototype.isValidDateTime(value[1]);
    }

    return isValid ? true : 'Data inválida';
  }

  private isValidDateTime(value) {
    const re = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/;
    return re.exec(value) != null;
  }

  private getFileExtension(format) {
    return format === 'PDF' ? '.pdf' : '.xls';
  }

  private exportAdvancedSearchToExcel() {
    const rules = $('#builder').queryBuilder('getRules');

    if (!$.isEmptyObject(rules)) {
      this.filter = rules;
      this.excel();
    }
  }

  private exportStorageCostsReportToExcel() {
    const rules = $('#builder').queryBuilder('getRules');

    if (this.vesselAndProcessId) {
      rules.rules.push({
        id: 'VesselAndProcessID',
        field: 'VesselAndProcessID',
        type: 'integer',
        value: this.vesselAndProcessId,
        operator: 'equal'
      });
    }

    if (this.customerId) {
      rules.rules.push({
        id: 'CustomerID',
        field: 'CustomerID',
        type: 'integer',
        value: this.customerId,
        operator: 'equal'
      });
    } 

    if (!$.isEmptyObject(rules)) {
      this.filter = rules;
      console.log(this.filter);    
      this.baseservice.exportExcel({ offset: 0, pageSize: 100 }, this.filter, 'ExportStorageCostsReportToExcel')
      .subscribe(return_value => {
        saveAs(return_value.blob, return_value.filename);
      },
      error => { console.log('Error exporting Excel ' + this.entity + ' ' + error); }
      );      
      // this.excel();
    }
  }  

  private exportCargoGuidesReportToExcel() {
    //this.excel();
    const rules = $('#builder1').queryBuilder('getRules');
    this.filter = rules;
    console.log(this.filter);  


    //$('#builder1').queryBuilder({
    //  allow_groups: false,
    //  filters: [{
    //    id: 'TruckingCompany.Designation',
    //    label: 'Empresa camionagem',
    //    type: 'string',
    //   operators: ['begins_with']
     // },
      //{
     //   id: 'VesselAndProcess.Designation',
      //  label: 'Navio e contramarca',
      //  type: 'string',
      //  operators: ['begins_with']
      //},      
      //{
       // id: 'CreatedOn',
        //label: 'Movimentado em',
        //type: 'datetime',        
        //placeholder: 'YYYY-MM-DD HH:mm:ss',        
        //operators: ['between'],
        //value_separator: ',',
        //validation: {
        ///  callback: this.validateDateTimeRule
        //}
      //}]
    //});


    //
    const request = {
      ReportNumber: this.reportNumber,
      TruckingCompanyId: this.truckingCompanyId,
      TruckRegistration: this.truckRegistration,
      TruckTrailer: this.truckTrailer
    };

        
      this.baseservice.exportExcel({ offset: 0, pageSize: 100 }, this.filter, 'ExportCargoGuidesReportToExcel')
      .subscribe(return_value => {
        saveAs(return_value.blob, return_value.filename);
      },
      error => { console.log('Error exporting Excel ' + this.entity + ' ' + error); }
      );      
      // this.excel();
    
  }  
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/mapas/mapa.component.ts